import { Component, Input, OnInit } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { TaxPayerSystemFormComponent } from "../TaxPayerSystem-from/TaxPayerSystem.component";
import { EntityListAction, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { filter, take, takeUntil } from "rxjs/operators";
import { Invoice } from "../../order/model/invoice.model";
import { ConfirmDateValue, DateDialogComponent } from "../../dateDialog/dateDialog.component";
import { Subject } from "rxjs";
import { TaxPayerSystemModel } from "projects/sepidz-web-framework/src/lib/models/TaxPayerSystem.model";
import { randomInt } from "crypto";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services";

@Component({
  selector: "ngx-taxPayer-list",
  templateUrl: "./TaxPayerSystem-list.component.html",
  styleUrls: ["./TaxPayerSystem-list.component.scss"],
})
export class TaxPayerSystemListComponent extends BaseListComponent {
  actions: EntityListAction[];
  onFilter: GridFilter[] = [];
  @Input() currentFilter: any;
  constructor() {
    super();
    this.inputEditorform = TaxPayerSystemFormComponent;
  }
  ngOnInit() {
    this.apiName = "TaxPayer";
    this.label = this.translate("ClientApp.FrontOffice.TaxPayerSystem.TaxPayerSystem");
    this.areaName = "RestaurantSale";
    this.setactions();
  }

  setactions() {
    this.actions = [
      {
        name: "taxPayerInquiry",
        disabled: false,
        displayName: this.translate("ClientApp.FrontOffice.TaxPayerSystem.GetLatestInvoiceStatus"),
        iconName: "icon-error_outline-o",
        apiName: "TaxPayer/GetInquiry",
        areaName: this.areaName,
        permission: Permission.viewPermission,
      },
    ];
  }
  onActionClick(action: EntityListAction) {
    //if (action.name === "taxPayerInquiry") {
    const confirmValue: Subject<ConfirmDateValue> = new Subject();
    confirmValue
      .pipe(
        filter((x) => !!x),
        take(1)
      )
      .subscribe((value) => {
        const taxPayer: TaxPayerSystemModel = {
          StartDate: value.StartDate,
          EndDate: value.EndDate,
          HasGetResponese: value.HasGetResponse,
          ResendFactors: value.ResendFactors,
          SendStatusCode: value.StatusCode,
        };
        this.setFilter(value);
        if (taxPayer.HasGetResponese) {
          this.httpCommonService
            .create("TaxPayer/GetInquiry", taxPayer)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data: any) => {},
              (err) => {
                console.log(err);
              }
            );
        }
        if (taxPayer.ResendFactors) {
          this.httpCommonService
            .create("TaxPayer/ResendFactors", taxPayer)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data: any) => {},
              (err) => {
                console.log(err);
              }
            );
        }
      });
    this.dialogService.open(
      DateDialogComponent,
      { confirmValue, autoCancel: false, hasResponse: true, hasResendFactors: true, statusList: true },
      {}
    );

    //}
  }

  public setFilter(value: ConfirmDateValue): void {
    this.onFilter = [];
    this.onFilter.push({
      Filed: "Code",
      Value: value.StatusCode,
      Skip: 0,
      Take: 0,
      Operator: "eq",
      Type: "F",
    });
    this.onFilter.push({
      Filed: "StartDate",
      Value: value.StartDate,
      Skip: 0,
      Take: 0,
      Operator: "gte",
      Type: "F",
    });
    this.onFilter.push({
      Filed: "EndDate",
      Value: value.EndDate,
      Skip: 0,
      Take: 0,
      Operator: "lte",
      Type: "F",
    });

    this.onFilter = Object.assign([], this.onFilter);
  }
}
